/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SELECTION_REF = ({
  //variable
  auth,
  layer,
  properties,

  //function
  set_value_properties,
  set_modal_selection_ref,
}) => {
  //localStorage
  const language = localStorage?.language || auth?.language;

  //state & ref

  //global props
  const { field_editable } = properties;
  const { geo_layer_list, layer_id } = layer;

  //variables
  const parent_array_templates_key = field_editable?.parent_array_templates_key;
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id,
  )?.geo_layer;
  const fields = geo_layer?.fields || [];

  //functions

  return (
    <main>
      <h1 className="text_bold margin_bottom">
        {
          dict[
            "Select another column as a reference for the fill value filter"
          ][language]
        }
      </h1>
      <Dropdown
        placeholder="Pilih"
        filter_on
        is_enable_empty={false}
        value={parent_array_templates_key}
        onChange={(value) => {
          set_value_properties({
            key: "field_editable",
            value: {
              ...field_editable,
              parent_array_templates_key: value,
            },
          });
          set_modal_selection_ref(false);
        }}
      >
        {fields.map((item, idx) => {
          return (
            <option key={item?.key} value={item?.key} id={idx}>
              {item?.name}
            </option>
          );
        })}
      </Dropdown>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(
  SELECTION_REF,
);
